import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_DOMAIND
    : process.env.REACT_APP_DOMAINP;

const instance = axios.create({ baseURL });

export default instance;
